/**
 * component ticket-create"
 */
<script>

import apiService from '../services/api-service.js';

export default {
  props: [
    'formAction',
    'genericErrorMessage',
    'confirmModalId',
    'initEdificioId'
  ],
  data() {
    return {
      ticketId: "0",
      edificioId: "0",
      ticketUserId: "0",
      ticketUserName: "",
      edificioNombre: "",
      areaRef: "0",
      areaName: "",
      deInteresGeneral: false,
      asunto: "",
      noteContent: "",
      alertMessage: "",
      isLoading: false,
      displayStep: "form"
    }
  },
  created() {
    this.edificioId = this.initEdificioId;
  },
  methods: {
    getPostParams: function(commit) {
      return {
        edificioId: this.edificioId,
        areaRef: this.areaRef,
        deInteresGeneral: this.deInteresGeneral ? "1" : "0",
        asunto: this.asunto,
        noteContent: this.noteContent,
        commit: commit ? "1" : "0"
      }
    },
    submitToValidate: function() {
      this.isLoading = true;
      this.alertMessage = "";
      axios({
        method: 'post',
        url: apiService.ajaxUrl + '-ticket-create',
        params: this.getPostParams(false)
      }).then(response => {
        this.isLoading = false;
        if(response.data.status == apiService.STATUS_OK) {
          this.ticketUserName = response.data.ticketUserName;
          this.edificioNombre = response.data.edificioNombre;
          this.areaName = response.data.areaName;
          $('#'+this.confirmModalId).modal('show');
        } else if(response.data.status == apiService.STATUS_VALIDATION_FAILED) {
          this.alertMessage = response.data.message;
        } else {
          this.alertMessage = this.genericErrorMessage;
        }
      }).catch(error => {
        this.isLoading = false;
        this.alertMessage = this.genericErrorMessage;
      });
    },
    submitToSave() {
      this.isLoading = true;
      this.alertMessage = "";
      axios({
        method: 'post',
        url: apiService.ajaxUrl + '-ticket-create',
        params: this.getPostParams(true)
      }).then(response => {
        this.isLoading = false;
        if(response.data.status == apiService.STATUS_OK) {
          $('#ticketCreateConfirmModal').modal('hide');
          this.displayStep = "success";
          this.displaySuccess = true;
        } else {
          this.alertMessag = response.data.message;
        }
      }).catch(error => {
        this.isLoading = false;
        this.alertMessage = this.genericErrorMessage;
        console.log(error);
      });
    },
    hideConfirmModal() {
      $('#'+this.confirmModalId).modal('hide');
    }
  }
};
</script>
